module.exports = __webpack_public_path__ + "img/Collectco.15ecca5f.png";